import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector as useReduxSelector
} from 'react-redux';
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import rootReducer, { RootState } from './rootReducer';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import hesApi from './hes/hesApi';
import veeApi from './vee/veeApi';
import authApi from './auth/authApi';
import userAccessApi from './user-access-panel/userAccessPanelAPI';
import rfFWApi from './legacy-rf-firmware-upgrade/fwUpgradeApi';
import nfmsApi from './nfms/nfmsApi';
import prepaidEngineApi from './prepaid-engine/prepaidEngineApi';

import MDMSFiltersAPI from './mdms-filters/MDMSFiltersAPI';
import satApi from './sat/satApi';
import dcuFWApi from './legacy-dcu-firmware-upgrade/dcuUpgradeApi';
import userAccessPanelAPIDLMS from './user-access-panel/DLMSUserAccessPanelAPI';
import energyAccountingApi from './energy-accounting/energyAccountingApi';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      hesApi.middleware,
      veeApi.middleware,
      authApi.middleware,
      userAccessApi.middleware,
      userAccessPanelAPIDLMS.middleware,
      prepaidEngineApi.middleware,
      rfFWApi.middleware,
      energyAccountingApi.middleware,
      dcuFWApi.middleware,
      nfmsApi.middleware,
      satApi.middleware,
      MDMSFiltersAPI.middleware
    )
});

setupListeners(store.dispatch);

export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>(); // Export a hook that can be reused to resolve types
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export default store;
